<template>
  <non-property-layout>
    <loading v-if="isUserLoading" />
    <div v-else>
      <div v-if="errorMsg">
        {{ errorMsg }}
      </div>
      <div v-else>
        <h1 class="text-xl font-bold py-6">Choose Property:</h1>
        <div
          v-for="portalListDto in portals"
          :key="portalListDto.portalId"
          class="py-3 pl-4 hover:bg-blue-200"
        >
          <router-link
            class="text-blue-800 w-full text-lg"
            :to="`/${portalListDto.siteCode}?login=true`"
          >
            {{ portalListDto.name }}
          </router-link>
        </div>
      </div>
    </div>
  </non-property-layout>
</template>

<script setup lang="ts">
import { useBldgStore } from "../store/bldgStore";
import { useUserStore } from "../store/userStore";

const bldgStore = useBldgStore();
const userStore = useUserStore();
const router = useRouter();

let client = ref("");
let errorMsg = ref<string | null>(null);
const isUserLoading = ref(true);

var portals = computed(() => bldgStore.portalList);

onMounted(loadData);

async function loadData() {
  isUserLoading.value = true;

  let clientSystemNameArr = router.currentRoute?.value?.params?.clientsystemname;
  let clientSystemName = Array.isArray(clientSystemNameArr)
    ? clientSystemNameArr[0]
    : clientSystemNameArr;

  await userStore.getUser("", 0, false, clientSystemName);

  let regionNameArr = router.currentRoute?.value?.params?.regionname;
  let regionName = Array.isArray(regionNameArr) ? regionNameArr[0] : regionNameArr;

  if (!userStore.isLoggedIn) {
    console.log("User not found logged in. Redirecting to login page");
    if (regionName) router.replace(`/client/${clientSystemName}/${regionName}`);
    else router.replace(`/client/${clientSystemName}`);
  }

  if (clientSystemName) {
    client.value = clientSystemName;
    if (regionName) {
      // Load list of portals for this region
      console.log(
        `Portal List page loading data for region: ${clientSystemName} > ${regionName} `
      );
      await bldgStore.getPortalList(clientSystemName, regionName);
    } else {
      // load list of portals for entire client
      console.log("Portal List page loading data for client: " + clientSystemName);
      await bldgStore.getPortalList(clientSystemName);
    }
  } else {
    errorMsg.value = "Sorry, theres a problem with this page. No client found.";
  }

  isUserLoading.value = false;
}
</script>
